// filepath: apps/web/src/features/promote/PromotionDiffRoute.tsx
//
// FR-UI-PROM-1: route shell for the promotion diff view.
//
// Mounts the PromotionDiffPage inside the AuthGuard.
// FR-UI-PROM-1 AC-3: server-side enforcement — the SPA navigates to this
// route only from the STAGING promotion review list.

import React from "react";
import { PromotionDiffPage } from "./PromotionDiffPage";

interface PromotionDiffRouteProps {
  reviewId: string;
}

/**
 * PromotionDiffRoute — route-level shell for the diff view.
 *
 * URL: /promote/diff?reviewId=<uuid>
 *
 * Note: environmentKind gating (FR-UI-PROM-1 AC-3) is enforced
 * server-side. The SPA only renders this route when the reviewer
 * navigates from the STAGING promotion review list.
 */
export function PromotionDiffRoute({
  reviewId,
}: PromotionDiffRouteProps): React.ReactElement {
  if (!reviewId) {
    return (
      <div className="p-6">
        <p className="text-muted-foreground text-sm">
          No reviewId specified. Navigate from the promotion review list.
        </p>
      </div>
    );
  }
  return <PromotionDiffPage reviewId={reviewId} />;
}
